export const safeTotal = (compute: () => { total: number; currentCurrency: string }, fallbackCurrency: string) => {
    try {
        const { total, currentCurrency } = compute();
        return { total, currency: currentCurrency };
    } catch {
        return { total: null, currency: fallbackCurrency };
    }
};
